module.exports = __webpack_public_path__ + "img/fork.435f2950.svg";